
/**
 * Return on bill cost ratio
 */
export default ({ initial_cost, annual_bill_savings_avg, prototype_id = 1 }) => {
  const prototypeRef = prototype_id == 1 ? 1.262632888 : 1.03636987
  return ((30 * parseFloat(annual_bill_savings_avg)) / (parseFloat(initial_cost) * prototypeRef))
}